<template>
  <div class="mt-80">
    <div class=" px-3 mb-5 pt-5 policy-block">
      Обязательным условием в моей работе является конфиденциальность. Я обязуюсь хранить в тайне сведения, которые вы предоставили о себе и других в ходе консультирования. В исключительных случаях, если вы просите подробнее разобрать вашу ситуацию в моих видеороликах или статьях, я разберу аналогичный случай, используя вымышленные истории или примеры из научной литературы.
    </div>
    <Videos/>
    <Footer/>
  </div>
</template>

<script>
  import Videos from '@/views/Home/components/Videos';
  import Footer from '@/views/Home/components/Footer';
  export default {
    name: "Policy",
    components: {Footer, Videos}
  }
</script>

<style scoped>
  .policy-block {
    max-width: 1040px;
    margin-left: auto;
    margin-right: auto;
    text-align: justify;
    display: block;
  }
</style>